<div [class]="groupName ? 'header-container weighted-left' : 'header-container single'">
    <h1 *ngIf="title" class="title">
      {{ title }}<span *ngIf="subtitle" class="subtitle"> {{ subtitle }}</span>
    </h1>
  <dxo-label-value *ngIf="groupName" [label]="GroupLabel" [values]="[groupName]" [subValue]="'#' + groupNumber" />
</div>
